import { Accessor } from '@deck.gl/core';
import { ScatterplotLayer } from '@deck.gl/layers';
import hiddable from '../modules/isHiddableModule.js';

export class HidableScatterplotLayer<TData, TProps = object> extends ScatterplotLayer<
    TData,
    { getIsHidden: Accessor<TData, number> } & TProps
> {
    initializeState() {
        super.initializeState();
        this.getAttributeManager()!.addInstanced({
            isHidden: {
                size: 1,
                accessor: 'getIsHidden',
                defaultValue: 0.0
            }
        });
    }

    getShaders() {
        const shaders = super.getShaders();
        return {
            ...shaders,
            modules: [...shaders.modules, hiddable]
        };
    }
}
